import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Knob } from 'primereact/knob';
import { Chart } from 'primereact/chart';
import { InputSwitch } from "primereact/inputswitch";
import { travelService } from '../../services/extensions';
const TravelAllRequest = () => {
    const [showDataTable, setShowDataTable] = useState(true);
    const [totalRequests, setTotalRequests] = useState(0);
    const [totalApproved, setTotalApproved] = useState(0);
    const [totalRejected, setTotalRejected] = useState(0);
    useEffect(() => {
        fetchTravelData();
    }, []);

    const fetchTravelData = () => {
        travelService.GetUserTravelcountforCEOandTravel()
            .then(response => {
                if (response.data.success) {
                    const { approvedCount, rejectCount, totalRequests } = response.data.data;
                    setTotalRequests(totalRequests);
                    setTotalApproved(approvedCount);
                    setTotalRejected(rejectCount);
                }
            })
            .catch(error => {
                console.error('Error fetching travel data:', error);
            });
    };

    const chartData = {
        labels: ['Total Requests', 'Total Approved', 'Total Rejected'],
        datasets: [
            {
                label: 'Travel Status',
                data: [totalRequests, totalApproved, totalRejected],
                backgroundColor: ['#66BB6A', '#42A5F5', '#FFA726'],
                hoverBackgroundColor: ['#64B5F6', '#81C784', '#FFB74D']
            }
        ]
    };

    const lightOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#64B5F6'
                }
            }
        }
    };

    return (
        <div className='col-12'> 
            <div className='flex col-12 justify-content-end'>
                <span style={{ marginRight: "10px" }}> <b>Table View</b> </span>
                <InputSwitch checked={showDataTable} onChange={(e) => setShowDataTable(e.value)} /> 
                <span style={{ marginLeft: "10px" }}><b>Chart View </b></span>
            </div>
            {showDataTable ? (
                <div className='grid col-12 mt-3'>
                    <div className='grid col-6'>
                        <div className="col-6 text-center">
                            <Knob value={totalRequests} readOnly valueColor="#42A5F5" />
                            <p>Total Requests</p>
                        </div>
                        <div className="col-6 text-center">
                            <Knob value={totalApproved} readOnly valueColor="#FFA726" />
                            <p>Total Approved</p>
                        </div>
                        <div className="col-6 text-center">
                            <Knob value={totalRejected} readOnly valueColor="#FFB74D" />
                            <p>Total Rejected</p>
                        </div>
                    </div>
                    <div className="col-6 text-right">
                    <Chart type="bar" data={chartData} options={lightOptions} style={{ width: '70%', display: 'flex' }}  />
                    </div>
                </div>
            ) : (
                <DataTable className="mt-4 leaves-data"
                    responsiveLayout="scroll"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    dataKey="id"
                    value={[{ totalRequests, totalApproved, totalRejected }]}
                    resizableColumns
                    columnResizeMode="fit"
                    scrollable="horizontal"
                    stripedRows
                    editMode="row"
                >
                    <Column field="totalRequests" header="Total Requests" />
                    <Column field="totalApproved" header="Total Approved" />
                    <Column field="totalRejected" header="Total Rejected" />
                </DataTable>
            )}


        </div>
    );
};

export default TravelAllRequest;
